module.exports = __webpack_public_path__ + "static/media/LoginPageAvatarImage10.bf20538e.webp";